module.exports = __webpack_public_path__ + "static/img/5.8faca59.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/eng/5.png
// module id = r4ZO
// module chunks = 0